import SodSidePanelSummary from './SodSidePanelSummary';

export default SodSidePanelSummary;
